import { injectIntl } from "react-intl";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from "@mui/material";
import { FOLLOW_UP_REQUEST, NO_LABEL, YES_LABEL } from "../../../modules/language";
import { SUBSCRIBE_EVENT, UNSUBSCRIBE_EVENT } from "../../../modules/tracking";
import { getMessageString } from "../../../utility";

export const ModaleFollowUp = injectIntl(({ intl, modalOpen, onClose }) => (
  <>
    <Typography sx={{ opacity: 0 }} id="followUpDialog">
      Modale richiesta follow up
    </Typography>
    <Dialog open={modalOpen} className="followUpAlert" aria-labelledby="followUpDialog">
      <DialogContent>
        <DialogContentText>{getMessageString(intl, FOLLOW_UP_REQUEST)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            window.dispatchEvent(new CustomEvent(UNSUBSCRIBE_EVENT));
            onClose();
          }}
        >
          {getMessageString(intl, NO_LABEL)}
        </Button>
        <Button
          onClick={() => {
            window.dispatchEvent(new CustomEvent(SUBSCRIBE_EVENT));
            onClose();
          }}
        >
          {getMessageString(intl, YES_LABEL)}
        </Button>
      </DialogActions>
    </Dialog>
  </>
));
